import { ALOE_100, ownUpBodyMixin } from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';

const TextArea = styled.textarea`
  width: 100%;
  height: 200px;
  padding: 8px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ccc;
  resize: vertical;
  ${ownUpBodyMixin};
  &:focus {
    outline: none;
    border-color: ${ALOE_100};
    box-shadow: 0 0 0 2px ${ALOE_100};
  }
`;

export const OwnUpTextArea = ({
  value,
  onChange,
  placeholder,
  style
}: {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}) => <TextArea style={style} placeholder={placeholder} value={value} onChange={onChange} />;
